import { AuthEmailDto, TokensDto, VerificationInstance } from '@sweatpals/shared';
import { AxiosInstance } from 'axios';

export class AuthService {
	private readonly httpClient: AxiosInstance;

	constructor(httpClient: AxiosInstance) {
		this.httpClient = httpClient;
	}

	public async signInWithGoogle(): Promise<TokensDto> {
		const { data } = await this.httpClient.get('/auth/google');

		return data;
	}

	public async signInWithPhone(login: string): Promise<VerificationInstance> {
		const { data } = await this.httpClient.post('/auth/signin/phone', { login });

		return data;
	}

	public async signUpWithPhone(phone: string): Promise<VerificationInstance> {
		const { data } = await this.httpClient.post('/auth/signup/phone', { phone });

		return data;
	}

	public async signInWithPhoneVerification(login: string, code: string): Promise<TokensDto> {
		const { data } = await this.httpClient.post('/auth/signin/phone/verification', { login, code });

		return data;
	}

	public async signInWithGoogleToken(idToken: string): Promise<TokensDto> {
		const { data } = await this.httpClient.post<TokensDto>('/auth/google', { idToken });

		return data;
	}

	public async signUpWithPhoneVerification(phone: string, code: string): Promise<TokensDto> {
		const { data } = await this.httpClient.post('/auth/signup/phone/verification', { phone, code });

		return data;
	}

	public async signInWithEmail(data: AuthEmailDto): Promise<TokensDto> {
		const { data: tokens } = await this.httpClient.post('/auth/signin/email', data);

		return tokens;
	}

	public async signUpWithEmail(data: AuthEmailDto): Promise<TokensDto> {
		const { data: tokens } = await this.httpClient.post('/auth/signup/email', data);

		return tokens;
	}

	public async signInOrSignUpWithPhone(
		phone: string
	): Promise<{ verification: VerificationInstance; isSignIn: boolean }> {
		try {
			return {
				verification: await this.signInWithPhone(phone),
				isSignIn: true,
			};
		} catch (error) {
			if (error.response?.status === 404) {
				return {
					verification: await this.signUpWithPhone(phone),
					isSignIn: false,
				};
			}
		}
	}

	public async signInOrSignUpWithEmail(
		email: string,
		password: string
	): Promise<{ tokens: TokensDto; isSignIn: boolean }> {
		try {
			return {
				tokens: await this.signInWithEmail({
					email,
					password,
				}),
				isSignIn: true,
			};
		} catch (error) {
			if (error.response?.status === 404) {
				return {
					tokens: await this.signUpWithEmail({
						email,
						password,
					}),
					isSignIn: false,
				};
			}
		}
	}
}
